import { render, staticRenderFns } from "./platformCouponGivenList.vue?vue&type=template&id=7f8dc64e&scoped=true"
import script from "./platformCouponGivenList.vue?vue&type=script&lang=ts"
export * from "./platformCouponGivenList.vue?vue&type=script&lang=ts"
import style0 from "./platformCouponGivenList.vue?vue&type=style&index=0&id=7f8dc64e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8dc64e",
  null
  
)

export default component.exports